import { useCallback, useEffect, useState } from 'react';
import { useNotificationStore } from '@/store/notifications';
import { notificationService } from '@/services/notification';
import { useAuth } from '@/contexts/AuthContext';

export function useNotificationBadge() {
  const { user } = useAuth();
  const unreadCount = useNotificationStore((state) => state.unreadCount);
  const setUnreadCount = useNotificationStore((state) => state.setUnreadCount);
  const setInitialized = useNotificationStore((state) => state.setInitialized);
  const initialized = useNotificationStore((state) => state.initialized);
  const reset = useNotificationStore((state) => state.reset);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUnreadCount = useCallback(async () => {
    if (!user) {
      reset();
      return;
    }

    setIsLoading(true);
    try {
      const result = await notificationService.getUnreadCount(user.id);
      if (result.success && typeof result.data === 'number') {
        setUnreadCount(result.data);
        setInitialized(true);
      }
    } catch (error) {
      console.error('[NotificationBadge] Failed to fetch unread count:', error);
    } finally {
      setIsLoading(false);
    }
  }, [user, reset, setUnreadCount, setInitialized]);

  useEffect(() => {
    if (!user) {
      reset();
      return;
    }

    if (!initialized && !isLoading) {
      fetchUnreadCount();
    }
  }, [user, initialized, isLoading, fetchUnreadCount, reset]);

  return {
    unreadCount,
    refreshUnreadCount: fetchUnreadCount,
    isLoading
  };
}
